<template>
<div id="hotel" :class="{'pa-2 ma-2':$vuetify.breakpoint.smAndUp}" v-scroll="onScroll" style="padding-bottom: 70px !important">

    <v-container fluid :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-0': $vuetify.breakpoint.xs, 'pt-3': $vuetify.breakpoint.smAndUp}">
        <v-row class="im-card-items">
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-hotel-details v-else class="im-card" :item="item" :config="config" @openDialog="edit_component='im-hotel-modal-details', dialog=true"></im-hotel-details>
            </v-col>
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-hotel-contact v-else class="im-card" :item="item" :config="config" @openDialog="edit_component='im-hotel-modal-contact', dialog=true"></im-hotel-contact>
            </v-col>
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-hotel-location v-else class="im-card" :item="item" :config="config" @openDialog="edit_component='im-hotel-modal-location', dialog=true"></im-hotel-location>
            </v-col>
            <v-col md="8" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-hotel-policy v-else class="im-card" :item="item" :config="config" @openDialog="edit_component='im-hotel-modal-policy', dialog=true"></im-hotel-policy>
            </v-col>
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-hotel-facilities v-else class="im-card" :item="item" :config="config" @openDialog="edit_component='im-hotel-modal-facilities', dialog=true"></im-hotel-facilities>
            </v-col>
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-hotel-billing v-else class="im-card" :item="item" :config="config"></im-hotel-billing>
            </v-col>
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-hotel-media v-else class="im-card" :item="item" :config="config" @openDialog="edit_component='im-hotel-modal-media', dialog=true"></im-hotel-media>
            </v-col>
        </v-row>
    </v-container>

    <!-- modal component -->
    <component :is="edit_component" :dialog="dialog" :item="this.$clone(item)" :config="config" @exit="dialog=false, edit_component = null" @update="updateHotel()" :is_mounted="is_mounted" @mounted="is_mounted = true" />
    <!--./ modal component -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import logger from "../../logger.js";
import defaults from "../../components/utils/PropDefaults.js";
import IMFooter from '../../components/utils/IMFooter.vue';
// cards
import IMHotelDetail from "../../components/items/Hotel/cards/Detail.vue";
import IMHotelContact from "../../components/items/Hotel/cards/Contact.vue";
import IMHotelLocation from "../../components/items/Hotel/cards/Geolocation.vue";
import IMHotelPolicy from "../../components/items/Hotel/cards/Policy.vue";
import IMHotelFacilities from "../../components/items/Hotel/cards/Facilities.vue";
import IMHotelMedia from "../../components/items/Hotel/cards/Media.vue";
import IMHotelBilling from "../../components/items/Hotel/cards/Billing.vue";
// modals
import IMHotelModalDetail from "../../components/items/Hotel/modals/Detail.vue";
import IMHotelModalContact from "../../components/items/Hotel/modals/Contact.vue";
import IMHotelModalLocation from "../../components/items/Hotel/modals/Geolocation.vue";
import IMHotelModalPolicy from "../../components/items/Hotel/modals/Policy.vue";
import IMHotelModalFacilities from "../../components/items/Hotel/modals/Facilities.vue";
import IMHotelModalMedia from "../../components/items/Hotel/modals/Media.vue";
import IMHotelModalBilling from "../../components/items/Hotel/modals/Billing.vue";

export default {
    props: ["hotel"],
    name: `item-hotel`,
    components: {
        //cards
        "im-hotel-details": IMHotelDetail,
        "im-hotel-contact": IMHotelContact,
        "im-hotel-billing": IMHotelBilling,
        "im-hotel-location": IMHotelLocation,
        "im-hotel-policy": IMHotelPolicy,
        "im-hotel-facilities": IMHotelFacilities,
        "im-hotel-media": IMHotelMedia,
        // modals
        "im-hotel-modal-details": IMHotelModalDetail,
        "im-hotel-modal-contact": IMHotelModalContact,
        "im-hotel-modal-billing": IMHotelModalBilling,
        "im-hotel-modal-location": IMHotelModalLocation,
        "im-hotel-modal-policy": IMHotelModalPolicy,
        "im-hotel-modal-facilities": IMHotelModalFacilities,
        "im-hotel-modal-media": IMHotelModalMedia,
        // footer
        "im-footer": IMFooter,
    },
    data() {
        return {
            dialog: false,
            edit_component: null,
            is_mounted: false,
            menu_hotel: false,
            offset_top: null,
            validate: false,
            active_component: {
                name: 'im-hotel-details',
                validate: true
            },
            hotel_components: [
                {
                    name: 'im-hotel-details',
                    title: 'details',
                    validate: true,
                }, {
                    name: 'im-hotel-contact',
                    title: 'contact',
                    validate: true,
                }, {
                    name: 'im-hotel-location',
                    title: 'geolocation',
                    validate: true,
                }, {
                    name: 'im-hotel-billing',
                    title: 'billing',
                    validate: true,
                }, {
                    name: 'im-hotel-policy',
                    title: 'policy',
                    validate: true,
                }, {
                    name: 'im-hotel-facilities',
                    title: 'facilities',
                    validate: true,
                }, {
                    name: 'im-hotel-media',
                    title: 'media',
                    validate: true,
                },
            ],
            hotel_component_name: 'im-hotel-details',
            config: {},
            loading_save: false,
            loading_data: false,
            tab_hotel: null,
            center_position: {
                lat: 44.439663,
                lng: 26.096306
            },
            new_images: [],
            default_image_id: null,
            selected_facilities_ids: [],
            selected_activities_ids: [],
            item: this.$clone(defaults.hotel_item),
            original: this.$clone(defaults.hotel_item),
            clone: this.$clone(defaults.hotel_item),
            original_slug: null,
            policy_children: this.$clone(defaults.hotel_item.static.policy.children),
            response: {
                hotel: {},
                policy_refundable: {},
                policy_nonrefundable: {},
                rate_plan: {},
                room_single: {},
                room_double: {},
            },

        };
    },

    watch: {
        'hotel.id': function (new_hotel, old_hotel) {
            if(new_hotel != this.$route.params.id) {
                this.$router.push({
                    path: '/' + this.hotel.slug + '/inventory-pricing'
                });
            }
        },

    },

    mounted() {
        this.getAllItems();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        onScroll(e) {
            this.offset_top = window.pageYOffset || document.documentElement.scrollTop;
            if(this.offset_top > 50) {
                this.menu_hotel = true;
            } else {
                this.menu_hotel = false;
            }
        },

        getAllItems() {
            this.loading_data = true;
            this.getItemConfigs()
                .then(() => this.getItem())
                .catch(error => {
                    console.error(error);
                    this.loading_data = false;
                })
                .finally(() => {
                    // this.loading_data = false;
                });
        },

        getItemConfigs() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/config';

            return this.$axios.get(endpoint)
                .then(response => {
                    this.config = response.data;
                    let accepted_cards = []
                    Object.keys(response.data.accepted_cards)
                        .forEach(function (item) {
                            accepted_cards.push({
                                slug: item,
                                text: response.data.accepted_cards[item]
                            })
                        })
                    this.config.accepted_cards_slug = accepted_cards;
                    this.config.unit_type_slug = Object.keys(response.data.unit_types);
                    this.config.currencies_slug = Object.keys(response.data.currencies);
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
        },

        getItem() {

            if(this.$route.params.id) {

                // setup query endpoint
                let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
                let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/" + this.$route.params.id;

                this.$axios.get(endpoint)
                    .then(response => {
                        this.item = response.data;
                        this.original_slug = response.data.slug;
                        this.center_position = {
                            lat: Number(this.item.static.geo.lat),
                            lng: Number(this.item.static.geo.lon)
                        }
                        // set new addres format to have nr and building details
                        if(!this.item.address) {
                            this.item.address = this.$clone(defaults.hotel_item.address)
                        }
                        if(!this.item.description) {
                            this.item.description = {
                                ro: '',
                                en: ''
                            }
                        }
                        this.original = this.$clone(this.item);
                        this.policy_children = this.$clone(this.item.static.policy.children);
                        this.original.static.defaults.stars = Number(this.original.static.defaults.stars)

                    })
                    .catch(error => {
                        logger.error(error.message, error.stack)
                            .then(() => null);
                        console.log(error);
                        this.error("Oops, something went wrong!");
                    })
                    .finally(() => {
                        this.loading_data = false;
                        // this.loading = false;
                    });
            }
        },

        updateHotel() {
            this.dialog = false;
            this.edit_component = null;
            this.getItem();
            this.$emit('refresh', this.hotel.id);
        },

        refresh() {
            this.new_images = [];
            this.default_image_id = null;
            this.getItem();
        },

    },

};
</script>
<style lang="stylus">
.border
    border-left: 2px solid black
    @media only screen and (max-width: 960px)
        border-left: none
        border-bottom: 2px solid black

.menu-hotel
    position: sticky
    top: 48px
    z-index: 2
    .list-menu
        background-color: white
        width: fit-content

.left-menu
    overflow: visible
    width: 180px
    @media only screen and (max-width: 960px)
        width: auto
        overflow-x: scroll

.back
    position: absolute
    height: 100%
    background-color: red
    left: 0
    top: 0
    -webkit-transition: width 2s
    /* For Safari 3.1 to 6.0 */
    transition: width 2s
.hotel-modal-header
    max-height: 50px
    font-size: 24px
    font-weight: 600
    color: #727E8C
.hotel-modal-title
    font-size: 18px
    font-weight: 500
    color: #727E8C
// .hotel-modal-footer
//     background-color: white
//     position: sticky
//     bottom: 0
.hotel-modal
    &.v-card
        .v-input
            .v-text-field__slot
                input
                    color: #3B4856
            .v-select__slot
                .v-select__selections
                    color: #3B4856
</style>
